module.exports = __webpack_public_path__ + "static/media/btn-apple-download.2928664f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/home/img/btn-apple-download.svg
// module id = 106
// module chunks = 0